export const AVAILABILITY_SLOT_OPTIONS = [
	{ id: '8-14', label: '8-14' },
	{ id: '14-20', label: '14-20' },
]

export const sortAvailabilitySlots = slots =>
	AVAILABILITY_SLOT_OPTIONS
		.map(option => option.id)
		.filter(id => Array.isArray(slots) && slots.includes(id))

export const hasAvailabilitySlot = (slots, slotId) => Array.isArray(slots) && slots.includes(slotId)
